// position must be "start"[to top] | "center"[to center] | 
// "end"[to bottom] | "nearest"[to nearest one of top or bottom]

export const scrollCardToPosition = (cardContainerRef, position = "start") => {
    cardContainerRef.firstElementChild.scrollIntoView({block: position, behavior: "smooth"})
}